import type { EntityAdapter } from "@/components/tables/entityAdapters/entityAdapter";

const FILTERS_SENT_WITHOUT_LOOKUP = ["checked", "billed"];

export const trackedServiceEntityAdapter: EntityAdapter = {
  entity: "trackedService",
  defaultSort: {
    sort: "-executed_on",
    tableSort: "executed_on",
    descending: true,
  },
  persistsTableStateInRedux: true,
  providesColumnFiltersToCustomAction: true,
  convertsPriceToEurocent: false,
  mapColumnFilter: (filter) =>
    FILTERS_SENT_WITHOUT_LOOKUP.includes(filter.column)
      ? { [filter.column]: filter.value }
      : undefined,
  afterColumnFilter: (filter, params) => {
    if (filter.column === "month") {
      delete params["month__icontains"];
      params["month"] = filter.value;
    }
  },
  isRowActionAllowed: (trackedService) =>
    trackedService.checked_on == null && trackedService.billed_on == null,
  toolbar: {
    customElementsPosition: "end",
    rowSelectionElementsPosition: "ownRow",
  },
};
